import React, { useState } from 'react';
import { string, object } from 'prop-types';
import { SvgIcon, styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import sassVars from 'styles/application/_base/_variables.scss';

const Header = styled('div')`
  margin: 36px 0 24px;
  font-size: ${pxToRem('16px')};
  font-weight: 900;
  line-height: 24px;
`;

const ToggleBtn = styled('button')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: ${pxToRem('16px')};
  font-weight: 900;
  line-height: 24px;
  letter-spacing: 0.4px;
`;

const HelpTextJss = styled('div')`
  font-size: ${pxToRem('16px')};
  font-weight: 500;
  text-align: left;
  letter-spacing: 0.24px;
  letter-spacing: 0.4px;
  color: ${sassVars.secondaryColor};
`;

const CloseBtn = styled('button')`
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  margin: 24px 16px 0 0;
  color: ${sassVars.secondaryColor};
  font-size: ${pxToRem('10px')};
  font-weight: 800;
  letter-spacing: 0.25px;
  border: none;
  background-color: white;
  cursor: pointer;
  > div {
    margin: 0 16px 0 0;
  }
`;

const Footer = styled('div')`
  height: 24px;
  margin: 0 0 24px;
  border-bottom: 1px solid ${sassVars.dividerColor};
`;

const Section = styled('section')<{ toggle: boolean }>`
  position: relative;
  max-height: ${({ toggle }) => (toggle ? '0' : '448px')};
  overflow: hidden;
  transition: all 0.5s ease-out;
`;

const SvgIconStyled = styled(SvgIcon)<{ toggle: boolean }>`
  transform: ${({ toggle }) => (toggle ? 'rotate(0deg)' : 'rotate(-180deg)')};
  transition: all 0.1s;
  &.MuiSvgIcon-root {
    width: 10px;
    height: 10px;
  }
`;

const SvgOpenClose = (props) => {
  return (
    <SvgIconStyled
      {...props}
      toggle={props.toggle}
      data-testid="PlatformAdminUI-TeamVoiceSettings-VoiceMailAdvanced-VoicemailRevealCard-SvgIcon"
      viewBox="0 0 11.289 7.854"
    >
      <path
        id="Shape"
        d="M9.031,7.854,5.645,4.488,2.258,7.854,0,5.61,5.645,0l5.645,5.61Z"
        transform="translate(11.289 7.854) rotate(180)"
        fill="#758BA3"
      />
    </SvgIconStyled>
  );
};

const RevealCard = ({
  title = ' Voicemail (advanced)',
  helpText = ' Configure busy greetings, voicemail to email, and storage options.',
  children,
}) => {
  const [toggle, setToggle] = useState(true);

  const onToggleReveal = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Header>
        <ToggleBtn
          onClick={onToggleReveal}
          type="button"
          data-testid="PlatformAdminUI-TeamVoiceSettings-VoiceMailAdvanced-VoicemailRevealCard-Title"
        >
          {title}
          <SvgOpenClose toggle={toggle} />
        </ToggleBtn>
        <HelpTextJss data-testid="PlatformAdminUI-TeamVoiceSettings-VoiceMailAdvanced-VoicemailRevealCard-HelperText">
          {helpText}
        </HelpTextJss>
      </Header>
      <Section toggle={toggle}>
        {children}
        <CloseBtn
          onClick={onToggleReveal}
          type="button"
          data-testid="PlatformAdminUI-TeamVoiceSettings-VoiceMailAdvanced-VoicemailRevealCard-CloseSection"
        >
          <div>Close this section</div>
          <SvgOpenClose toggle={toggle} />
        </CloseBtn>
      </Section>
      <Footer />
    </>
  );
};

RevealCard.propTypes = {
  children: object.isRequired,
  helpText: string,
  title: string,
};

export default RevealCard;
